import { AUTH0_PATH } from '@/components/layers/Auth0Layer/constants';
import type { PageHref } from '@/lib/routesMetadata';
import { Routes } from './Routes';

export { AUTH0_PATH };

export const REDIRECT_URL_PARAM = 'redirectUrl' as 'redirectUrl';
export const LOGIN_HINT_PARAM = 'login_hint' as 'login_hint';

// Pages do not need authorization
export const PUBLIC_PAGES: PageHref[] = [
  AUTH0_PATH.LOGIN as PageHref,
  AUTH0_PATH.LOGOUT as PageHref,
  Routes.AUTH_ERROR,
  Routes.REGISTRATION,
  Routes.LEGAL_TERMS_OF_SERVICE,
  Routes.LEGAL_PRIVACY_POLICY,
];

// Detailed validation is in CurrentUserModel.isPageAvailable
export const PROTECTED_FEATURE_PAGES: PageHref[] = [
  Routes.DASHBOARD,
  Routes.INCIDENTS,
  Routes.REPORTS,
  Routes.GEOPOLITICAL_INTELLIGENCE,
  Routes.NARRATIVE_INTELLIGENCE,
  Routes.SEARCH_CONSOLE,
  Routes.EMBEDDED_SUPPLY_CHAIN,
  Routes.EMBEDDED_INTELLIGENCE_DASHBOARD,
  // TEMP(ankara-poc-demo): Ankara NATO POC demo — remove after the demo.
  Routes.EMBEDDED_ANKARA_POC,
];

export const CUSTOM_HEADERS = {
  'x-user-id': 'x-user-id',
  'x-pathname': 'x-pathname',
} as const;
